/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { SecurityScheme } from '../../../core/models/common/SecurityScheme';
import { Oas20Scopes } from './Oas20Scopes';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {string} schemeName
 * @class
 * @extends SecurityScheme
 * @author eric.wittmann@gmail.com
 */
export class Oas20SecurityScheme extends SecurityScheme {
    public flow : string;

    public authorizationUrl : string;

    public tokenUrl : string;

    public scopes : Oas20Scopes;

    public constructor(schemeName : string) {
        super(schemeName);
        if(this.flow===undefined) this.flow = null;
        if(this.authorizationUrl===undefined) this.authorizationUrl = null;
        if(this.tokenUrl===undefined) this.tokenUrl = null;
        if(this.scopes===undefined) this.scopes = null;
    }

    /**
     * Create the scopes.
     * @return {Oas20Scopes}
     */
    public createScopes() : Oas20Scopes {
        let scopes : Oas20Scopes = new Oas20Scopes();
        scopes._ownerDocument = this.ownerDocument();
        scopes._parent = this;
        return scopes;
    }
}
Oas20SecurityScheme["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20SecurityScheme";
Oas20SecurityScheme["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




